import Router from '../Router';
import { Store } from '../Store';
import {
  ROUTES_ACCESSIBLE_IF_NOT_LOGGED_IN,
  ROUTES_ACCESSIBLE_AFTER_LOGGED_IN,
} from '../Variables';

export const beforeEachRoute = Router.beforeEach((to, from, next) => {
  Store.watch(state => {
    if (state.auth.user == null) {
      if (!ROUTES_ACCESSIBLE_IF_NOT_LOGGED_IN.includes(to.name)) {
        Store.dispatch('url/setPrevious', to.fullPath);
        return Router.push('/login');
      }

      next();
    }

    if (state.auth.user !== null) {
      if (ROUTES_ACCESSIBLE_IF_NOT_LOGGED_IN.includes(to.name)) {
        Router.push(state.url.previous);
      }

      next();
    }
  });
});
